import styled from 'styled-components';

export const BannerContainer = styled.div`
  align-items: center;
  justify-content: center;
  height: calc(100vh - var(--header-min-height));

  &:before {
    background-image: url('../../assets/image002.jpeg');
    background-position: center;
    background-size: cover;
    content: '';
    height: calc(100vh - var(--header-min-height));
    position: absolute;
    width: 100%;
  }
`;

export const BannerText = styled.h1`
  align-items: flex-start;
  background-color: rgba(199, 208, 103, 0.5);
  display: flex;
  flex-direction: column;
  font-family: arial black, serif;
  font-size: 35px;
  height: 100%;
  justify-content: center;
  padding: 10px;
  position: relative;
  width: 100%;
`;

export const CarouselContainer = styled.div`
  margin: 30px auto;
  width: 80vw;
`;